import React from "react";
import {Box, IconButton, StarIcon } from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";

const OutlinedIconButton = () => {

  return (
    <Box p={3} sx={{ width: "80%", margin: "0 auto" }}>
      <PreviewAndEditor
        background
        title={"Outlined IconButtons"}
        height={"150px"}
        language={"js"}
        value={
          '        <IconButton variant={"outlined"}>\n' +
          "          <StarIcon />\n" +
          "        </IconButton>\n" +
          '        <IconButton variant={"outlined"} color={"primary"}>\n' +
          "          <StarIcon />\n" +
          "        </IconButton>\n" +
          '        <IconButton variant={"outlined"} color={"secondary"}>\n' +
          "          <StarIcon />\n" +
          "        </IconButton>\n" +
          '        <IconButton variant={"outlined"} color={"error"}>\n' +
          "          <StarIcon />\n" +
          "        </IconButton>\n" +
          '        <IconButton variant={"outlined"} color={"warning"}>\n' +
          "          <StarIcon />\n" +
          "        </IconButton>\n" +
          '        <IconButton variant={"outlined"} color={"info"}>\n' +
          "          <StarIcon />\n" +
          "        </IconButton>\n" +
          '        <IconButton variant={"outlined"} color={"success"}>\n' +
          "          <StarIcon />\n" +
          "        </IconButton>\n" +
          '        <IconButton variant={"outlined"} color={"inherit"}>\n' +
          "          <StarIcon />\n" +
          "        </IconButton>\n" +
          '        <IconButton variant={"outlined"} color={"inheritWhite"}>\n' +
          "          <StarIcon />\n" +
          "        </IconButton>\n" +
          '        <IconButton variant={"outlined"} disabled>\n' +
          "          <StarIcon />\n" +
          "        </IconButton>"
        }
      >
        <IconButton variant={"outlined"}>
          <StarIcon />
        </IconButton>
        <IconButton variant={"outlined"} color={"primary"}>
          <StarIcon />
        </IconButton>
        <IconButton variant={"outlined"} color={"secondary"}>
          <StarIcon />
        </IconButton>
        <IconButton variant={"outlined"} color={"error"}>
          <StarIcon />
        </IconButton>
        <IconButton variant={"outlined"} color={"warning"}>
          <StarIcon />
        </IconButton>
        <IconButton variant={"outlined"} color={"info"}>
          <StarIcon />
        </IconButton>
        <IconButton variant={"outlined"} color={"success"}>
          <StarIcon />
        </IconButton>
        <IconButton variant={"outlined"} color={"inherit"}>
          <StarIcon />
        </IconButton>
        <IconButton variant={"outlined"} color={"inheritWhite"}>
          <StarIcon />
        </IconButton>
        <IconButton variant={"outlined"} disabled>
          <StarIcon />
        </IconButton>
      </PreviewAndEditor>
    </Box>
  );
};

export default OutlinedIconButton;
